import { Component, OnInit } from "@angular/core";
import { CheckinCheckoutService } from "src/app/services/checkin-checkout.service";
import { Config } from "src/app/utility/config";
import { FormGroup, FormBuilder } from "@angular/forms"; // Import FormGroup and FormBuilder
import { ToastrService } from "ngx-toastr";
import { EmployeeService } from "../../hrm/employee/employee.service";

@Component({
  selector: "app-lms-time-dashboard",
  templateUrl: "./lms-time-dashboard.component.html",
  styleUrls: ["./lms-time-dashboard.component.scss"],
})
export class LmsTimeDashboardComponent implements OnInit {
  userObj: any;
  userData: any;
  user: any;
  user_Id: any;
  userType: any;
  FromDate: any;
  // val: any = 'Month'
  toDate: any;
  userForm: FormGroup;
  commnetForm: FormGroup;
  user_IdLocal: any;
  userDataforemployee: any;
  Status: any;
  AdminCheckoutforEmployee: any;
  ModalOpen: boolean;
  CurrentAttendance_Id: any;
  commentList: any;
  GSTComment: any;
  AttendanceComment: any;
  localUserName: any;
  EmpoloyeeList: any;
  EmpoloyeeListFiltered: any;
  Formet: any;
  SelectedUser_Id: any;
  EmployeeAttendanceDataByUserId: any;
  ShowListByUserIdOnly: boolean = true;

  constructor(
    private config: Config,
    private api: CheckinCheckoutService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private empoloyeeApi: EmployeeService
  ) {
    this.userForm = this.fb.group({
      employee: [""],
      from: [""],
      to: [""],
    });
    this.commnetForm = this.fb.group({
      comment_Id: [0],
      comment: [""],
      attendance_Id: [0],
      commentBy: [0],
      commentByName: [""],
      isDeleted: true,
      dts: [""],
    });
  }

  ngOnInit(): void {
    this.GetUser();
    this.userObj = JSON.parse(localStorage.getItem("userObj"));
    this.user_IdLocal = this.userObj.userInfo.user_Id;
    this.userType = this.userObj.userInfo.role_Id;
    this.user_Id = this.userObj.userInfo.user_Id;
    this.localUserName = this.userObj.userInfo.full_Name;

    // Check user role and load data accordingly
    if (this.userType === 0) {
      this.getallattendencelistforadmin();
    } else {
      this.loaddataforemployee();
    }
    this.getEmployeeListFormanager();
  }

  IsManagerAdmin() {
    if (this.userType === 9 || this.userType === 0) {
      return true;
    } else {
      return false;
    }
  }
  GetUser() {
    this.api.getalluser().subscribe((res) => {
      this.user = res.user;
    });
  }

  selectFromDate(val: any) {
    this.FromDate = val;
  }
  selectToDate(val: any) {
    this.toDate = val;
  }

  User(event: any) {
    this.SelectedUser_Id = event.target.value;
  }

  getEmployeeListFormanager() {
    this.config.startLoader();
    this.empoloyeeApi.GetmanagerEmployee(this.user_IdLocal).subscribe((res) => {
      this.config.stopLoader();
      this.EmpoloyeeList = res.user;
      this.EmpoloyeeListFiltered = res.user;
    });
  }

  loadUserDataForAdmin() {
    if (
      this.SelectedUser_Id === 0 ||
      this.SelectedUser_Id === null ||
      typeof this.SelectedUser_Id === "undefined"
    ) {
      this.toastr.error("Please Select Employee.", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });
      return;
    }
    if (
      this.FromDate === null ||
      typeof this.FromDate === "undefined" ||
      this.toDate === null ||
      typeof this.toDate === "undefined"
    ) {
      this.config.startLoader();
      this.api
        .GetTimeSheetDataByUser_Id(this.SelectedUser_Id)
        .subscribe((res) => {
          console.log("res", res);

          this.config.stopLoader();
          if (res.status === "1") {
            this.ShowListByUserIdOnly = false;
            this.EmployeeAttendanceDataByUserId = res.result;

            console.log(
              "EmployeeAttendanceDataByUserId",
              this.EmployeeAttendanceDataByUserId
            );
          }
        });
    }
    if (this.SelectedUser_Id && this.FromDate && this.toDate) {
      this.config.startLoader();
      this.userForm.value.employee = this.SelectedUser_Id;
      this.api
        .getallcheckincheckoutByuserId(
          this.SelectedUser_Id,
          this.FromDate,
          this.toDate
        )
        .subscribe((res) => {
          console.log("getallcheckincheckoutByuserId", res);

          this.config.stopLoader();
          if (res.status === "1") {
            this.userData = res.result;
          }
        });
    }
  }

  loadUserData() {
    console.log("user_Id:", this.user_IdLocal);
    if (
      this.user_IdLocal === 0 ||
      this.user_IdLocal === null ||
      typeof this.user_IdLocal === "undefined"
    ) {
      this.toastr.error("Please Select Employee.", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });
      return;
    }
    if (
      this.FromDate === null ||
      typeof this.FromDate === "undefined" ||
      this.toDate === null ||
      typeof this.toDate === "undefined"
    ) {
      this.config.startLoader();
      this.api.GetTimeSheetDataByUser_Id(this.user_IdLocal).subscribe((res) => {
        this.config.stopLoader();
        if (res.status === "1") {
          this.ShowListByUserIdOnly = false;
          this.EmployeeAttendanceDataByUserId = res.result;
          console.log(
            "EmployeeAttendanceDataByUserId",
            this.EmployeeAttendanceDataByUserId
          );
        }
      });
    }
    if (this.user_IdLocal && this.FromDate && this.toDate) {
      this.config.startLoader();
      this.userForm.value.employee = this.user_IdLocal;
      this.api
        .getallcheckincheckoutByuserId(
          this.user_IdLocal,
          this.FromDate,
          this.toDate
        )
        .subscribe((res) => {
          this.config.stopLoader();
          if (res.status === "Success") {
            this.ShowListByUserIdOnly = true;
            this.userData = res.result;
          }
        });
    }
  }

  parseCustomDate(dateString: string): Date {
    const [datePart, timePart, period] = dateString.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    let [hours, minutes, seconds] = timePart.split(":").map(Number);

    if (period === "PM" && hours < 12) {
      hours += 12;
    }
    if (period === "AM" && hours === 12) {
      hours = 0;
    }

    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  formatTime(date: Date): string {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const period = hours >= 12 ? "PM" : "AM";

    const formattedHours = hours % 12 || 12; // Convert to 12-hour format
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes; // Add leading zero

    return `${formattedHours}:${formattedMinutes} ${period}`;
  }
  getallattendencelistforadmin() {
    this.config.startLoader();
    this.api.getallcheckincheckout().subscribe((res) => {
      this.config.stopLoader();
      if (res.status === "1") {
        this.userData = res.qrtReportsList;

        console.log(this.userData);
      }
    });
  }

  loaddataforemployee() {
    this.config.startLoader();
    this.api.getallcheckincheckoutForEmp(this.user_IdLocal).subscribe((res) => {
      console.log("res", res);

      this.config.stopLoader();
      if (res.status === "1") {
        this.userDataforemployee = res.qrtReportsList;
      }
    });
  }

  ShowReport() {
    if (this.userType === 0) {
      this.loadUserData();
      // this.loadDefaultData();
    } else {
      this.loadUserDataForUserRole();
    }
  }

  loadUserDataForUserRole() {
    // Implement logic to load user-specific data based on their role
  }

  User_Id(User_Id: any, FromDate: string, toDate: string) {
    throw new Error("Method not implemented.");
  }

  // AdminCheckout(userId: any) {
  //   this.config.startLoader();
  //   this.api.CheckoutAdmin(userId).subscribe((res) => {
  //     this.config.stopLoader();
  //     if (res.status === '1') {
  //       this.getallattendencelistforadmin()
  //     }
  //   });
  // }
  AdminCheckout(userId: any) {
    if (this.userType === 0 || this.userType === 9) {
      this.config.startLoader();
      this.api.CheckoutAdmin(userId).subscribe((res) => {
        this.config.stopLoader();
        if (res.status === "1") {
          this.getallattendencelistforadmin();
        }
      });
    }
  }

  openModel(attendanceId) {
    this.ModalOpen = true;
    this.CurrentAttendance_Id = attendanceId;
    this.GstComment();
  }

  // Save comment

  saveComments() {
    if (
      this.commnetForm.value.comment === "" ||
      this.commnetForm.value.comment === null ||
      typeof this.commnetForm.value.comment === "undefined"
    ) {
      this.toastr.error("Please enter comment.", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });
      return;
    }
    this.commnetForm.value.comment_Id = this.commnetForm.value.comment_Id || 0;
    this.commnetForm.value.comment = this.commnetForm.value.comment;
    this.commnetForm.value.attendance_Id = this.CurrentAttendance_Id;
    this.commnetForm.value.commentBy = this.user_IdLocal;
    this.commnetForm.value.commentByName = this.localUserName;
    this.commnetForm.value.isDeleted = false;
    this.commnetForm.value.dts = this.config.getCurrentDate();
    this.config.startLoader();
    this.api.SaveComments(this.commnetForm.value).subscribe((res) => {
      this.config.stopLoader();
      if (res.status === "1") {
        this.toastr.success("Saved successfully!", "", {
          timeOut: 4000,
          closeButton: true,
          enableHtml: true,
          positionClass: "toast-top-right",
          toastClass: "alert alert-success alert-with-icon",
        });
        this.commentList = res.taskComments;
        this.commnetForm.reset();
        this.GstComment();
      } else {
        this.toastr.error(res.message, "", {
          timeOut: 4000,
          closeButton: true,
          enableHtml: true,
          positionClass: "toast-top-right",
          toastClass: "alert alert-success alert-with-icon",
        });
      }
    });
  }

  GstComment() {
    this.api.GetCommentById(this.CurrentAttendance_Id).subscribe((res) => {
      this.AttendanceComment = res.result;
    });
  }
  cancel() {
    this.ModalOpen = false;
    this.commnetForm.reset();
  }
  ReportFromet(event: any) {
    console.log("Val", event.target.value);
    this.Formet = event.target.value;
  }
  exportData() {
    if (this.SelectedUser_Id === 0 || this.SelectedUser_Id === null) {
      this.toastr.error("Please Select Employee", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });
      return;
    }
    if (this.FromDate === "" || this.FromDate === null) {
      this.toastr.error("Please Select Start Date ", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });
      return;
    }
    if (this.toDate === "" || this.toDate === null) {
      this.toastr.error("Please Select End Date", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });
      return;
    }
    if (
      this.SelectedUser_Id ||
      (this.user_Id && this.FromDate && this.toDate)
    ) {
      const format = this.Formet || "Excel";

      const downloadURL = `${
        this.config.APIUrl
      }QRT_Attendance/Reports?Login_Key=debug1&UserId=${
        this.SelectedUser_Id || this.user_Id
      }&StartDate=${this.FromDate}&EndDate=${this.toDate}&Format=${format}`;

      window.location.href = downloadURL;
    } else {
      this.toastr.error("Please Select Valid Data", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });
    }
  }
}
